import { Actions } from 'vuex-smart-module';

import { IActionItem } from '../types';

import * as API from '../api';

import ActionsState from './state';
import ActionsGetters from './getters';
import ActionsMutations from './mutations';

let getActionsPromise: Nullable<Promise<IActionItem[]>> = null;

export default class ActionsActions extends Actions<
  ActionsState,
  ActionsGetters,
  ActionsMutations,
  ActionsActions
> {
  getActions(): Promise<IActionItem[]> {
    if (getActionsPromise) {
      return getActionsPromise;
    }

    const preloadedList = this.getters['settings'].list;
    if (preloadedList) {
      this.commit('setActions', preloadedList);
      return Promise.resolve(preloadedList);
    }

    return (getActionsPromise = API.getActions()
      .then((actions) => {
        this.commit('setActions', actions);
        return actions;
      })
      .finally(() => {
        getActionsPromise = null;
      }));
  }
}
